import { PRODUCT_MODE_MAP } from '../constants';

const AI_ALERTS_TITLE = 'AI Alerts';
const AI_ALERTS_SENSITIVITY_CONTROL_TITLE = 'AI Alerts Config';

const ALERT_TYPE_CONTEXT_MAP = {
  AD_ALERT: PRODUCT_MODE_MAP.AI,
  APP_ALERT: PRODUCT_MODE_MAP.APP,
  VIDEO_ALERT: PRODUCT_MODE_MAP.EI,
};

const productMap = {
  [PRODUCT_MODE_MAP.EI]: 'ei',
  [PRODUCT_MODE_MAP.AI]: 'ai',
  [PRODUCT_MODE_MAP.APP]: 'ae',
};

const VSI_AI_ALERTS_CUSTOM_DIMENSIONS_UPPER_LIMIT = 22;

const AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS = [
  {
    value: 'EI',
    label: 'Video',
  },
  {
    value: 'AI',
    label: 'Ad',
  },
  {
    value: 'APP',
    label: 'App',
  },
];

const GraphColors = {
  baseline: '#BD10E0',
  threshold: '#0046FF',
  exceptAnamoly: '#6a8e3b',
  issueStarted: '#4A4A4A',
  pcpDrop: '#F3D4D4',
  pcpDropBorder: '#C32828',
};

const DEFAULT_SENSITIVITY_CONFIG_FOR_METRIC = {
  deviation: '1.00',
  app: 'ei',
  asf: 1,
  sustain: 3,
  warningSustain: null,
  criticalSustain: null,
  impactedUnique: 5,
  impactedUniquePct: 0,
  warningImpactedUnique: null,
  warningImpactedUniquePct: null,
  criticalImpactedUnique: null,
  criticalImpactedUniquePct: null,
  sustainPcpDrop: 10,
  warningPcpDrop: null,
  criticalPcpDrop: null,
};

// Defaults for the Beta KPI metrics (meeting-agreed): 3 min persistence, 100 impacted
// devices, 0% threshold. Same shape as DEFAULT_SENSITIVITY_CONFIG_FOR_METRIC otherwise.
const DEFAULT_SENSITIVITY_CONFIG_FOR_KPI_METRIC = {
  deviation: '1.00',
  app: 'ei',
  asf: 1,
  sustain: 3,
  warningSustain: null,
  criticalSustain: null,
  impactedUnique: 100,
  impactedUniquePct: 0,
  warningImpactedUnique: null,
  warningImpactedUniquePct: null,
  criticalImpactedUnique: null,
  criticalImpactedUniquePct: null,
  sustainPcpDrop: 10,
  warningPcpDrop: null,
  criticalPcpDrop: null,
};

const DEFAULT_SENSITIVITY_CONFIG_FOR_APP_METRIC = {
  deviation: '1.00',
  app: 'ae',
  asf: 1,
  sustain: 3,
  warningSustain: null,
  criticalSustain: null,
  impactedUnique: 5,
  impactedUniquePct: 0,
  warningImpactedUnique: null,
  warningImpactedUniquePct: null,
  criticalImpactedUnique: null,
  criticalImpactedUniquePct: null,
  impactedFlows: 10,
  impactedFlowsPct: 0,
  warningImpactedFlows: null,
  warningImpactedFlowsPct: null,
  criticalImpactedFlows: null,
  criticalImpactedFlowsPct: null,
  sustainPcpDrop: 10,
  warningPcpDrop: null,
  criticalPcpDrop: null,
};

const DEFAULT_SENSITIVITY_CONFIG_FOR_AD_METRIC = {
  deviation: '1.00',
  app: 'ai',
  asf: 8,
  sustain: 1,
  warningSustain: null,
  criticalSustain: null,
  impactedUnique: 10,
  impactedUniquePct: null,
  warningImpactedUnique: null,
  warningImpactedUniquePct: null,
  criticalImpactedUnique: null,
  criticalImpactedUniquePct: null,
};

// disabled two of the device series based on product input
const deviceLabels = {
  //impactedUniques: 'Impacted Unique Devices',
  //totalUniques: 'Total Unique Devices',
  cumulativeImpactedUniques: 'Cumulative Impacted Unique Devices',
  totalCumulativeImpactedUniques: 'Total Cumulative Unique Devices',
  allExceptAnomaly: 'All except anomaly',
};
const deviceSeriesKeys = Object.keys(deviceLabels);

const AI_ALERT_DIAGNOSTIC_CHART_LABEL_MAP = {
  APP: {
    PCP_OR_PCT: 'PCT Drop',
  },
  EI: {
    PCP_OR_PCT: 'PCP Drop',
  },
  AI: {
    PCP_OR_PCT: 'PCP Drop',
  },
};

export {
  AI_ALERTS_TITLE,
  AI_ALERTS_SENSITIVITY_CONTROL_TITLE,
  AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS,
  DEFAULT_SENSITIVITY_CONFIG_FOR_METRIC,
  DEFAULT_SENSITIVITY_CONFIG_FOR_KPI_METRIC,
  DEFAULT_SENSITIVITY_CONFIG_FOR_AD_METRIC,
  DEFAULT_SENSITIVITY_CONFIG_FOR_APP_METRIC,
  GraphColors,
  deviceLabels,
  deviceSeriesKeys,
  AI_ALERT_DIAGNOSTIC_CHART_LABEL_MAP,
  ALERT_TYPE_CONTEXT_MAP,
  productMap,
  VSI_AI_ALERTS_CUSTOM_DIMENSIONS_UPPER_LIMIT,
};
